module.exports = __webpack_public_path__ + "img/photo_2023-11-27 11.39.45.3568260b.jpg";